export const utah = {
  "49000": "Utah",
  "49001": "Beaver County",
  "49003": "Box Elder County",
  "49005": "Cache County",
  "49007": "Carbon County",
  "49009": "Daggett County",
  "49011": "Davis County",
  "49013": "Duchesne County",
  "49015": "Emery County",
  "49017": "Garfield County",
  "49019": "Grand County",
  "49021": "Iron County",
  "49023": "Juab County",
  "49025": "Kane County",
  "49027": "Millard County",
  "49029": "Morgan County",
  "49031": "Piute County",
  "49033": "Rich County",
  "49035": "Salt Lake County",
  "49037": "San Juan County",
  "49039": "Sanpete County",
  "49041": "Sevier County",
  "49043": "Summit County",
  "49045": "Tooele County",
  "49047": "Uintah County",
  "49049": "Utah County",
  "49051": "Wasatch County",
  "49053": "Washington County",
  "49055": "Wayne County",
  "49057": "Weber County",
};
